import { createSlice } from "@reduxjs/toolkit";
import {toast} from 'react-toastify';


export const cartSlice= createSlice({
    name:'cart',
    initialState:{
        cartList: localStorage.getItem("cartItems") ? JSON.parse(localStorage.getItem("cartItems")) : [],
        cartTotalQuantity:0,
        cartTotalAmount:0
    },
    reducers:{
        addNewProductToCart:(state,action)=>{
           const index = state.cartList.findIndex(item=>item._id === action.payload._id)
           if(index>=0){
            state.cartList[index].quantity+=1;
            toast.success(`${state.cartList[index].name} quantity increased`,{
                position:'bottom-left',
                theme:"colored"
            })
           }else{
            const tempProduct = {...action.payload,quantity: action.payload.quantity || 1}
            state.cartList.push(tempProduct)
            toast.success(`${tempProduct.name} Added to Cart!`,{
                position:'bottom-left',
                theme:"colored"
            })
           }
        //    set item to local storage 
           localStorage.setItem("cartItems",JSON.stringify(state.cartList));
        },
        removeItemFromCart:(state,action)=>{
            const newCartItems = state.cartList.filter(item=>item._id !== action.payload._id)
            state.cartList = newCartItems;
            localStorage.setItem("cartItems",JSON.stringify(state.cartList));
            toast.error(`${action.payload.name} removed from cart.`,{
                position:'bottom-left',
                theme:"colored"
            })
        },
        decreaseQuantity:(state,action)=>{
            const index = state.cartList.findIndex(item=>item._id === action.payload._id);
            if(state.cartList[index].quantity >1){
                state.cartList[index].quantity -= 1;
                toast.info(`decreased ${action.payload.name} quantity`,{
                    position:'bottom-left',
                    theme:"colored"
                })
            }
            localStorage.setItem("cartItems",JSON.stringify(state.cartList));
        },
        getTotals: (state,action)=>{
            let {total,cartQuantity} = state.cartList.reduce((cartTotal,item)=>{
                const {price,quantity} = item;
                const itemTotal = price * quantity;
                cartTotal.total += itemTotal;
                cartTotal.cartQuantity += quantity;
                return cartTotal;
            },{total:0,cartQuantity:0})

            state.cartTotalAmount = total;
            state.cartTotalQuantity = cartQuantity;
            localStorage.setItem('total',JSON.stringify(total));
            localStorage.setItem('quantity',JSON.stringify(cartQuantity));
        },
        clearCartItems:(state,action)=>{
            state.cartList = []
            localStorage.setItem("cartItems",JSON.stringify(state
                .cartList))
            toast.success(`Cleared All Products from Cart`,{
                position:'bottom-left',
                theme:"colored"
            })
        },
        clearCart:(state,action)=>{
            state.cartList = []
            localStorage.setItem("cartItems",JSON.stringify(state
                .cartList))
        }


    }
})


export const {addNewProductToCart,removeItemFromCart,decreaseQuantity,getTotals,clearCartItems,increaseQuantity,clearCart} = cartSlice.actions;
export default cartSlice.reducer;
